
const locaisObito = [
  { name: 'Via pública', val: 'VIA_PUBLICA' },
  { name: 'Domicílio', val: 'DOMICILIO' },
  { name: 'Hospital', val: 'HOSPITAL' },
  { name: 'Ambulância', val: 'AMBULANCIA' },
  { name: 'Posto de Saúde', val: 'POSTO_SAUDE' },
  { name: 'Samu', val: 'SAMU' },
  { name: 'Outros serviços de saúde', val: 'OUTROS_SERVICOS_SAUDE' },
  { name: 'Ignorado', val: 'IGNORADO' },
  { name: 'Outro', val: 'OUTRO' },
]

const locaisObitoObj = {
  VIA_PUBLICA: 'Via pública',
  DOMICILIO: 'Domicílio',
  HOSPITAL: 'Hospital',
  AMBULANCIA: 'Ambulância',
  POSTO_SAUDE: 'Posto de Saúde',
  SAMU: 'Samu',
  OUTROS_SERVICOS_SAUDE: 'Outros serviços de saúde',
  IGNORADO: 'Ignorado',
  OUTRO: 'Outro',
}

export { locaisObito, locaisObitoObj }
